import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App'
// ---- Official Meta Pixel (base code) — PageView only ----
// Loads fbq, initializes the Pixel and tracks a single PageView on load.
// Checkout / Purchase events are handled exclusively by Shopify; no manual
// InitiateCheckout / AddPaymentInfo / Purchase events are fired here.
;
(function (f: any, b: Document, e: string, v: string) {
  if (f.fbq) return;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = b.createElement(e) as HTMLScriptElement;
  t.async = true;
  t.src = v;
  const s = b.getElementsByTagName(e)[0];
  s.parentNode?.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
(window as any).fbq('init', '2054642012133298');
(window as any).fbq('track', 'PageView');
// ---- End Meta Pixel ----
render(<App data-id="element-217" />, document.getElementById('root'));